














































import {
    Component,
    Prop,
    Vue,
    ComponentConfig,
    Product,
    ProductRecommendation,
    ComponentStyle,
    ComponentStyleDefinition,
    Watch
} from "@zoovu/runner-browser-api";
import {ProductRatingConfiguration} from "../configuration";

const RATING_PRECISION: number = 0.25;

@Component({})
export default class ProductRatingView extends Vue {

    @Prop()
    product: Product;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @ComponentConfig(ProductRatingConfiguration)
    componentConfiguration;

    enabled: boolean = false;

    mounted() {
        if (!this.ratingConfiguration) return;
        this.enabled = this.ratingConfiguration.enabled;
    }

    @Watch("componentConfiguration", {deep: true})
    requestUpdate() {
        this.$forceUpdate();
    }

    get ratingConfiguration() {
        if (!this.componentConfiguration) return null;
        return this.componentConfiguration.showProductRating;
    }

    get showRating(): boolean {
        if (!this.ratingConfiguration || !this.ratingConfiguration.enabled) {
            return false;
        }

        const ratingPropertyName = this.ratingConfiguration.rating.attribute.name;
        return this.hasPropertyValue(ratingPropertyName);
    }

    get showReviews(): boolean {
        if (!this.ratingConfiguration.reviews || !this.ratingConfiguration.reviews.enabled) {
            return false;
        }

        const reviewsPropertyName = this.ratingConfiguration.reviews.attribute.name;
        return this.hasPropertyValue(reviewsPropertyName);
    }

    get currentRate(): number {
        const ratingPropertyName = this.ratingConfiguration.rating.attribute.name;
        let ratingValue = this.getPropertyValue(ratingPropertyName) || 0;
        if (typeof ratingValue === "string") {
            ratingValue = parseFloat(ratingValue.replace(",", "."));
        }
        return this.normalizeValue(ratingValue);
    }

    get currentReviews(): number {
        const reviewsPropertyName = this.ratingConfiguration.reviews.attribute.name;
        const reviewsValue = this.getPropertyValue(reviewsPropertyName) || 0;
        return parseInt(reviewsValue);
    }

    getPropertyValue(propertyName: string): any {
        if (!this.product.additionalProperties[propertyName]) {
            const foundProperty = (this.product as ProductRecommendation).properties.find(property => property.rawValue.property === propertyName);
            if (!foundProperty) return null;
            return foundProperty.rawValue.value;
        }
        return this.product.additionalProperties[propertyName].value;
    }

    hasPropertyValue(propertyName: string): boolean {
        const property: any = this.getPropertyValue(propertyName);
        return property !== null;
    }

    get ratingRange(): { rated: boolean }[] {
        const rangeFromConfiguration = this.normalizeRangeValues();
        const ratingLength = rangeFromConfiguration.max - rangeFromConfiguration.min;

        return Array.apply(null, Array(ratingLength))
            .map((element, index) => {
                const stepValue = rangeFromConfiguration.min + index;
                if (this.currentRate > stepValue) {
                    return {
                        rated: true,
                        half: this.currentRate < stepValue + 1,
                    };
                }
                return {};
            });

    }

    normalizeRangeValues(): { min: number; max: number; } {
        return {
            max: Math.round(this.ratingConfiguration.range.max),
            min: Math.round(this.ratingConfiguration.range.min)
        };
    }

    normalizeValue(ratingValue: number) {
        if (ratingValue > (Math.ceil(ratingValue) - RATING_PRECISION)) {
            return Math.ceil(ratingValue);
        }

        if (ratingValue < (Math.floor(ratingValue) + RATING_PRECISION)) {
            return Math.floor(ratingValue);
        }

        return ratingValue;
    }
}
